// src/cache/donationCache.ts
import type { DonationListResponse } from "../types/donation";

// Define the shape of our cached donation data.
interface CachedDonations {
  data: DonationListResponse;
  timestamp: number;
}

// Unique key for localStorage.
const CACHE_KEY = "donationsCache";
// Time-to-live: cache is valid for 30 seconds (reduced from 1 minute for fresher data).
const CACHE_TTL = 30 * 1000;

export function getCachedDonations(): DonationListResponse | null {
  //console.log("Checking donation cache");
  const cachedString = localStorage.getItem(CACHE_KEY);
  if (!cachedString) return null;

  try {
    const cached: CachedDonations = JSON.parse(cachedString);
    // If cached data is still fresh, return it.
    if (Date.now() - cached.timestamp < CACHE_TTL) {
      //console.log(`Using cached donation data (age: ${Math.round((Date.now() - cached.timestamp)/1000)}s)`);
      return cached.data;
    } else {
      //console.log(`Cache expired (age: ${Math.round((Date.now() - cached.timestamp)/1000)}s)`);
      localStorage.removeItem(CACHE_KEY);
      return null;
    }
  } catch (err) {
    console.error("Error parsing cached donation data:", err);
    localStorage.removeItem(CACHE_KEY);
    return null;
  }
}

export function setCachedDonations(data: DonationListResponse): void {
  //console.log("Caching new donation data");
  const cached: CachedDonations = {
    data,
    timestamp: Date.now(),
  };
  localStorage.setItem(CACHE_KEY, JSON.stringify(cached));
}

export function clearCachedDonations(): void {
  //console.log("Clearing donation cache");
  localStorage.removeItem(CACHE_KEY);
}
